// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__UpRen","inner":"Form_inner__V45Ep","range":"Form_range__10qXM","name":"Form_name__1YXQV","actions":"Form_actions__3iLos"};